module.exports = __webpack_public_path__ + "img/levelup-icon-arrow-back.c40c91ab.svg";